import React, { useContext, useEffect, useState } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonIcon, useIonViewWillEnter, IonButtons, IonBackButton, IonFab, IonFabButton, IonFabList } from '@ionic/react'
import { ConfigContext } from '../../contexts/ConfigContext'
import db from '../../resources/db'
import { toastController } from '@ionic/core'
import { funnel, add } from 'ionicons/icons'

import { APPLINKS } from '../../resources/AppConst'

import PurchaseTable from './PurchaseTable'

const PurchaseList = (props) => {

    const { getPurchase } = useContext(ConfigContext);
    const [Purchase, setPurchase] = useState([]);
    const [InvList, setInvList] = useState([])

    useEffect(() => {
        getPurchase().then(res => {
            console.log(res);
            setPurchase(res)
            setInvList(res)
        })
        return () => {
            setPurchase([])
            setInvList([]);
        }
    }, [getPurchase])

	/** Remove Bill / Bill by id
	 * @param id
	 */
    const removeBill = (id) => {
        db.purchase.delete(id).then((res) => {
            toastController.create({
                color: 'danger',
                duration: 2000,
                message: 'Bill Removed.',
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
            console.log("Bill Removed", res);
        })
        db.purchase.reverse().toArray().then((res) => {
            setPurchase(res)
            setInvList(res)
        })
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Purchase List</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>

                <PurchaseTable data={InvList} removeBill={removeBill} />

                <IonFab vertical="top" horizontal="end" slot="fixed" edge>
                    <IonFabButton>
                        <IonIcon icon={funnel} />
                    </IonFabButton>
                    <IonFabList side='start'>
                        <IonFabButton color='danger' size='small' onClick={() => {
                            let gstbills = Purchase.filter((bill) => bill.gstEnabled)
                            setInvList(gstbills)
                        }}>GST</IonFabButton>
                        <IonFabButton size="small" onClick={() => {
                            let normbills = Purchase.filter((bill) => !bill.gstEnabled)
                            setInvList(normbills)
                        }}>Normal</IonFabButton>
                        <IonFabButton color='success' size="small" onClick={() => {
                            setInvList(Purchase)
                        }}>All</IonFabButton>
                    </IonFabList>
                </IonFab>

                <IonFab vertical="bottom" horizontal="end" slot="fixed" onClick={() => { props.history.push(APPLINKS.purchaseEntry) }}>
                    <IonFabButton color='danger'>
                        <IonIcon icon={add} />
                    </IonFabButton>
                </IonFab>

            </IonContent>
        </IonPage>
    )
}

export default PurchaseList
